<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M8 5a1 1 0 011-1h10a1 1 0 011 1v10a1 1 0 11-2 0V7.414L5.707 19.707a1 1 0 11-1.414-1.414L16.586 6H9a1 1 0 01-1-1z"/></svg>